import React, { useEffect, useState } from "react";
import classes from "./Hero.module.scss";

const Hero = ({ image, title, slogan }) => {
  const [state, setState] = useState({
    scale: 1.08,
    opacity: 0.42,
    titleIn: false,
    sloganIn: false,
  });

  useEffect(() => {
    window.scrollTo(0, 0);

    const introTimer = setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        scale: 1,
        titleIn: true,
        opacity: 0.46,
      }));
    }, 250);

    const sloganTimer = setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        sloganIn: true,
      }));
    }, 650);

    const handleScroll = () => {
      const nextScale = Math.min(1.12, 1 + window.scrollY / 4200);
      setState((prevState) => ({
        ...prevState,
        scale: nextScale,
      }));
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      clearTimeout(introTimer);
      clearTimeout(sloganTimer);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <section className={classes.hero} aria-label={title}>
      <img
        src={image}
        alt=""
        className={classes.heroImage}
        style={{
          transform: `scale(${state.scale})`,
        }}
      />

      <div className={classes.heroFilter} style={{ opacity: state.opacity }} />

      <div className={classes.heroContent}>
        <p className={classes.heroEyebrow}>Remedial Building Specialists</p>

        <h1
          className={`${classes.heroHeader} ${
            state.titleIn ? classes.heroHeaderVisible : ""
          } ${!slogan ? classes.heroNoSlogan : ""}`}
        >
          {title}
        </h1>

        {slogan && (
          <p
            className={`${classes.heroSlogan} ${
              state.sloganIn ? classes.heroSloganVisible : ""
            }`}
          >
            {slogan}
          </p>
        )}
      </div>
    </section>
  );
};

export default Hero;
